import React from 'react';
import { PersistGate } from 'redux-persist/lib/integration/react';

import './styles/global.scss';
import './styles/grid.scss';
import './styles/temps.scss';

import OpenBankStoreProvider from './containers/OpenBankStoreProvider';
import OpenBankingRouter from './OpenBankingRouter';
import { persistor } from './redux/store';

function App() {
  return (
      <OpenBankStoreProvider>
        <PersistGate persistor={persistor} loading={<div></div>}>
          <OpenBankingRouter />
        </PersistGate>
      </OpenBankStoreProvider>
  );
}

export default App;
